<!-- ===== LOTTERY DETAIL HEADER ===== -->
<div class="row mb-4" *ngIf="lottery?._id">
  <div class="col-12">
    <div class="card card-body lottery-header-card">

      <!-- Title Row -->
      <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-4">
        <div>
          <span class="status-badge mb-2 d-inline-flex align-items-center" [ngClass]="{
              'status-completed': lottery?.status === 'completed',
              'status-active':    lottery?.status === 'active',
              'status-pending':   lottery?.status === 'pending'
            }">
            <span class="status-dot"></span>
            {{ lottery?.status | titlecase }}
          </span>
          <h2 class="lottery-title mt-1 mb-1">{{ lottery?.lotteryName }}</h2>
          <p class="text-muted mb-0 small">
            <i class="fa fa-calendar-o mr-1"></i>
            Expires: {{ lottery?.expiryDate | date:'mediumDate' }}
            <span *ngIf="lottery?.drawCompletedAt" class="ml-3">
              <i class="fa fa-flag-checkered mr-1"></i>
              Draw completed: {{ lottery?.drawCompletedAt | date:'mediumDate' }}
            </span>
          </p>
        </div>
        <button class="btn btn-outline-secondary btn-sm align-self-start" (click)="goBack()">
          <i class="fa fa-arrow-left mr-1"></i> Back to Lottery
        </button>
      </div>

      <!-- Stats Row -->
      <div class="row stats-row mb-4">
        <div class="col-sm-4 mb-3 mb-sm-0">
          <div class="stat-card">
            <div class="stat-icon-wrap stat-icon-participants">
              <i class="fa fa-users"></i>
            </div>
            <div class="stat-body">
              <div class="stat-label">Participants</div>
              <div class="stat-value">{{ lottery?.totalParticipatedOrders || 0 }}</div>
              <div class="stat-sub">entered automatically</div>
            </div>
          </div>
        </div>
        <div class="col-sm-4 mb-3 mb-sm-0">
          <div class="stat-card">
            <div class="stat-icon-wrap stat-icon-winners">
              <i class="fa fa-trophy"></i>
            </div>
            <div class="stat-body">
              <div class="stat-label">Winners</div>
              <div class="stat-value">
                {{ lottery?.winners?.length || 0 }}
                <span class="stat-divider">/</span>
                {{ lottery?.winnerConfiguration?.length || 0 }}
              </div>
              <div class="stat-sub">selected</div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="stat-card">
            <div class="stat-icon-wrap stat-icon-window">
              <i class="fa fa-clock"></i>
            </div>
            <div class="stat-body">
              <div class="stat-label">Entry Window</div>
              <div class="stat-value">{{ lottery?.status === 'completed' ? 'Closed' : 'Open' }}</div>
              <div class="stat-sub">{{ lottery?.status === 'completed' ? 'draw complete' : 'accepting entries' }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- About + Winners panels -->
      <div class="row">

        <!-- About This Draw -->
        <div class="col-md-4 mb-4 mb-md-0">
          <div class="detail-panel h-100">
            <h6 class="panel-heading">
              <i class="fa fa-info-circle mr-2"></i>About this draw
            </h6>
            <div class="detail-rows">
              <div class="detail-row">
                <span class="detail-key"><i class="fa fa-list-ol mr-2 text-muted"></i>Required Orders</span>
                <span class="detail-val">{{ lottery?.requiredOrders || '-' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-key"><i class="fa fa-credit-card mr-2 text-muted"></i>Min. Order Value</span>
                <span class="detail-val">&#8377;{{ lottery?.minimumOrderValue || '-' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-key"><i class="fa fa-random mr-2 text-muted"></i>Selection Type</span>
                <span class="detail-val">{{ lottery?.winnerSelectionType | titlecase }}</span>
              </div>
              <div class="detail-row" *ngIf="lottery?.expiryDate">
                <span class="detail-key"><i class="fa fa-calendar mr-2 text-muted"></i>Expiry Date</span>
                <span class="detail-val">{{ lottery?.expiryDate | date:'mediumDate' }}</span>
              </div>
              <div class="detail-row" *ngIf="lottery?.drawCompletedAt">
                <span class="detail-key"><i class="fa fa-check-circle mr-2 text-muted"></i>Draw Completed</span>
                <span class="detail-val">{{ lottery?.drawCompletedAt | date:'medium' }}</span>
              </div>
            </div>

            <!-- Progress -->
            <div class="mt-3 pt-3 border-top">
              <div class="d-flex justify-content-between mb-1">
                <small class="text-muted">Progress</small>
                <small class="text-muted font-weight-bold">{{ lottery?.progressPercentage || 0 }}%</small>
              </div>
              <div class="progress lottery-progress">
                <div class="progress-bar" [style.width.%]="lottery?.progressPercentage || 0" [ngClass]="{
                    'bg-success': lottery?.progressPercentage >= 100,
                    'bg-primary': lottery?.progressPercentage > 0 && lottery?.progressPercentage < 100
                  }">
                </div>
              </div>
              <small class="text-muted">
                {{ lottery?.totalParticipatedOrders || 0 }} / {{ lottery?.requiredOrders || 0 }} orders
              </small>
            </div>
          </div>
        </div>

        <!-- Winners Panel -->
        <div class="col-md-8">
          <div class="detail-panel h-100">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h6 class="panel-heading mb-0">
                <i class="fa fa-trophy mr-2 text-warning"></i>Winners
                <span class="badge badge-light ml-2 font-weight-normal">
                  {{ lottery?.winners?.length || 0 }} selected
                </span>
              </h6>
            </div>

            <!-- Draw complete notice -->
            <div class="draw-notice mb-3" *ngIf="lottery?.status === 'completed' && lottery?.winners?.length > 0">
              <i class="fa fa-check-circle text-success mr-2"></i>
              Draw completed &middot; {{ lottery?.winners?.length }} winner{{ lottery?.winners?.length > 1 ? 's' : '' }}
              selected &middot; notified automatically
            </div>

            <!-- No winners yet -->
            <div class="text-center text-muted py-3" *ngIf="!lottery?.winners?.length">
              <i class="fa fa-hourglass-half fa-2x mb-2 d-block"></i>
              No winners selected yet
            </div>

            <!-- Winners Grid (3-column, scrollable) -->
            <div class="winners-scroll" *ngIf="lottery?.winners?.length > 0">
              <div class="winner-card" *ngFor="let winner of lottery?.winners">

                <!-- Rank strip -->
                <div class="rank-strip" [ngClass]="getRankClass(winner.rank)">
                  <i class="fa fa-trophy mr-1"></i>
                  <span>{{ getOrdinal(winner.rank) }} PRIZE</span>
                </div>

                <!-- Card body: avatar + info + prize -->
                <div class="winner-body">
                  <div class="winner-avatar" [ngClass]="getAvatarClass(winner.rank)">
                    <img *ngIf="winner?.user?.image" [src]="winner?.user?.image" [alt]="winner?.user?.name"
                      class="winner-avatar-img">
                    <span *ngIf="!winner?.user?.image" class="avatar-initials">
                      {{ getInitials(winner?.user?.name || winner?.user?.username) }}
                    </span>
                  </div>

                  <div class="winner-info">
                    <div class="winner-name">{{ winner?.user?.name || winner?.user?.username || '-' }}</div>
                    <div class="winner-meta" *ngIf="winner?.user?.phone_number">
                      <i class="fa fa-phone"></i>
                      {{ winner?.user?.countryCode ? '+' + winner?.user?.countryCode + ' ' : '' }}{{
                      winner?.user?.phone_number }}
                    </div>
                    <div class="winner-meta" *ngIf="winner?.user?.email">
                      <i class="fa fa-envelope"></i> {{ winner?.user?.email }}
                    </div>
                  </div>

                  <div class="winner-prize-wrap">
                    <div class="prize-amount">&#8377;{{ winner?.prizeAmount | number }}</div>
                    <div class="prize-label">PRIZE</div>
                  </div>
                </div>

                <!-- Card footer: awarded date -->
                <div class="winner-footer" *ngIf="winner?.awardedAt">
                  <i class="fa fa-calendar-o mr-1"></i>
                  Awarded: {{ winner?.awardedAt | date:'mediumDate' }}
                </div>

              </div>
            </div>
            <!-- end winners-scroll -->

          </div>
        </div>
        <!-- end winners col -->

      </div>
      <!-- end row about+winners -->

    </div>
  </div>
</div>
<!-- ===== END LOTTERY DETAIL HEADER ===== -->


<!-- ===== PARTICIPANTS TABLE ===== -->
<div class="row">
  <div class="col-12">
    <div class="card card-body">

      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Lottery Participants
        </h4>
        <button class="btn btn-outline-secondary btn-sm" (click)="goBack()" *ngIf="!lottery?._id">
          <i class="fa fa-arrow-left mr-1"></i> Back to Lottery
        </button>
      </div>

      <div class="table-responsive mt-2">
        <div *ngIf="loading" class="text-center py-4">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>

        <table class="table table-striped border" *ngIf="!loading">
          <thead class="table-light">
            <tr>
              <th scope="col">#</th>
              <th scope="col">User Name</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Order Number</th>
              <th scope="col">Status</th>
              <th scope="col">Participation Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of list; let i = index; trackBy: trackById" [ngClass]="getWinnerRowClass(item._id)">
              <td>{{ (page - 1) * pageSize + i + 1 }}</td>
              <td>
                {{ item?.user?.name || '-' }}
                <ng-container *ngIf="getWinnerInfo(item._id) as winInfo">
                  <span class="tbl-winner-badge" [ngClass]="{
                      'tbl-badge-gold':   winInfo.rank === 1,
                      'tbl-badge-silver': winInfo.rank === 2,
                      'tbl-badge-bronze': winInfo.rank === 3,
                      'tbl-badge-other':  winInfo.rank > 3
                    }">
                    <i class="fa fa-trophy"></i> {{ getOrdinal(winInfo.rank) }}
                  </span>
                </ng-container>
              </td>
              <td>{{ item?.user?.email || '-' }}</td>
              <td>{{ item?.user?.phone_number || '-' }}</td>
              <td>{{ item?.orderNumber || '-' }}</td>
              <td>
                <span class="badge" [ngClass]="{
                    'badge-success': item?.participationStatus === 'active',
                    'badge-warning': item?.participationStatus === 'pending',
                    'badge-danger':  item?.participationStatus === 'inactive'
                  }">
                  {{ item?.participationStatus | titlecase }}
                </span>
              </td>
              <td>{{ item?.participationDate | date:'mediumDate' }}</td>
              <td>
                <a href="javascript:void(0);" class="link mr-2" (click)="viewDetails(item._id)"
                  ngbTooltip="View Details">
                  <i class="fa fa-eye"></i>
                </a>
              </td>
            </tr>

            <tr *ngIf="list?.length === 0 && !loading">
              <td colspan="8" class="text-center text-muted py-3">
                No participants found for this lottery.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-center mt-3" *ngIf="!loading && list?.length > 0">
          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalCount" [maxSize]="7"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)">
          </ngb-pagination>
        </div>
      </div>

    </div>
  </div>
</div>